import React from "react";
import { MapPin, CalendarDays, Users } from "lucide-react";
import { CAMPS_OPEN } from "@/components/camps/campConfig";
import { CampFees } from "@/components/camps/CampFees";
import { CampAction } from "@/components/camps/CampAction";

const InfoRow = ({ icon: Icon, children }) => (
  <div className="flex items-start gap-3">
    <Icon size={16} className="mt-1 text-[#C4A46A] shrink-0" />
    <span>{children}</span>
  </div>
);

const PartnerLogo = ({ partner, slug, label }) => (
  <a
    href={partner.href}
    target="_blank"
    rel="noopener noreferrer"
    title={partner.name}
    data-testid={`camp-partner-logo-${slug}`}
    className="mt-8 pt-6 border-t border-[#0F1B2D]/10 flex items-center gap-4 group"
  >
    <img src={partner.logo} alt={partner.name} className="h-12 w-auto max-w-[80px] object-contain" loading="lazy" />
    <div className="leading-tight">
      <div className="text-[10px] tracking-[0.24em] uppercase font-bold text-[#5E6470]">{label}</div>
      <div className="mt-1 font-display text-[15px] text-[#0F1B2D] group-hover:text-[#C4A46A] transition-colors">{partner.name}</div>
    </div>
  </a>
);

export const CampCard = ({ c, camp, index, onChoose }) => {
  const campOpen = CAMPS_OPEN || Boolean(camp.registerHref);
  return (
    <article
      data-testid={`camp-${camp.slug}`}
      className="bg-[#F4F0E8] p-10 lg:p-12 flex flex-col hover:bg-white transition-colors"
    >
      <div className="font-display text-[#C4A46A] text-sm">{String(index + 1).padStart(2, "0")}</div>
      <h3 className="mt-4 font-display text-2xl lg:text-3xl text-[#0F1B2D] tracking-tight">{camp.city}</h3>
      <span className="gold-rule mt-4 block" />
      <div className="mt-6 space-y-4 text-[#5E6470] text-[15px]">
        <InfoRow icon={MapPin}>{camp.venue || c.tbaCard}</InfoRow>
        <InfoRow icon={CalendarDays}>{camp.dateRange || c.tbaCard}</InfoRow>
        {camp.ages && <InfoRow icon={Users}>{c.ageLabel}: {camp.ages}</InfoRow>}
      </div>
      {campOpen && camp.fees && <CampFees c={c} camp={camp} />}
      {camp.partner && <PartnerLogo partner={camp.partner} slug={camp.slug} label={c.partnershipLabel} />}
      <CampAction c={c} camp={camp} onChoose={onChoose} />
    </article>
  );
};
